import { Outlet } from '@tanstack/react-router';
import { type CSSProperties, useState } from 'react';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { getPreferences } from '@/lib/preferences';
import { AppSidebar } from './app-sidebar';
import { PageBarContext } from './page-bar';

/**
 * Studio shell: the sidebar sits on the grey canvas; each page is a rounded panel inset from the
 * window, with a fixed bar on top (filled by the page's `PageHeader`) and its own scroll area.
 */
export function AppLayout() {
  const [bar, setBar] = useState<HTMLElement | null>(null);
  return (
    <SidebarProvider
      defaultOpen={!getPreferences().compactSidebar}
      style={{ '--sidebar-width': '15rem' } as CSSProperties}
    >
      <AppSidebar />
      <SidebarInset className="shadow-panel md:peer-data-[variant=inset]:shadow-panel overflow-hidden md:h-[calc(100dvh-1rem)] md:peer-data-[variant=inset]:rounded-3xl">
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-3">
          <SidebarTrigger aria-label="Toggle navigation" className="md:hidden" />
          <div ref={setBar} className="flex min-w-0 flex-1 items-center gap-2" />
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto">
          <PageBarContext.Provider value={bar}>
            <div className="w-full p-4 md:p-5">
              <Outlet />
            </div>
          </PageBarContext.Provider>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
